import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
import { getErrMessages } from 'app/utils/errorHandler';
import { showMessage } from 'app/store/core/messageSlice';

export const getNotifications = createAsyncThunk(
  'notificationPanel/getData',
  async ({ _request, props = [] }, { dispatch, rejectWithValue }) => {
    try {
      const response = await _request(...props);
      const data = await response?.data;
      const notifications = await data.map((notification) => {
        return _.omit(notification, [
          'targetModel',
          'targetId',
          'targetPlatform',
          'updated_at',
          'deleted_at',
          'response',
          'attempts',
        ]);
      });
      return { notifications };
    } catch (error) {
      const errArray = getErrMessages(error);
      const message = errArray.join();
      dispatch(showMessage({ message }));
      return rejectWithValue({ errors: errArray });
    }
  }
);

